import React, { FC } from 'react';

import RideDataInfoChartLine from '../ride-data-info-chart-line/ride-data-info-chart-line';

import './ride-data-info-chart.scss';

interface RideDataInfoChartSeries {
  label: string;
  value: number;
}

interface RideDataInfoChartProps {
  Icon: FC;
  maxLabel: string;
  minLabel: string;
  series: Array<RideDataInfoChartSeries>;
  title: string;
}

function RideDataInfoChart(props: RideDataInfoChartProps) {
  const { Icon, title, maxLabel, minLabel, series } = props;

  return (
    <div styleName="container">
      <div styleName="row">
        <div styleName="title">
          <Icon styleName="icon" />
          <strong>{title}</strong>
        </div>
        <div styleName="chart-labels">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      </div>
      {series?.map((entry, i) => (
        <div key={`row-chart-${i}`} styleName="row-chart">
          <RideDataInfoChartLine
            hideTickLabels={i !== series.length - 1}
            {...entry}
          />
        </div>
      ))}
    </div>
  );
}

export default RideDataInfoChart;
